export default __webpack_public_path__ + "static/media/filter.4546628c.png";